import React, { PureComponent } from "react";
import ScGridTable from "@/components/display/table/gridTableCore";
import FormCore from "@/components/display/form/formCore";
import {} from "@/fetch/fetchApi";
import PropTypes from "prop-types";
import { Modal } from "antd";
import CityDataFilterHoc from "@/hoc/form/cityDataHoc";
import fetchHandler from "@/fetch/fetchHandler";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@CityDataFilterHoc
@connect((state) => state)
class EquipmentListModalDel extends PureComponent {
  constructor(props) {
    super(props);
    // 获取父组件传递的参数
    this.props = props;
    this.internationalization = this.props.intl.messages.equipmentListModalDel;
    const selectedRowKeys = this.props.selectedStations
      && this.props.selectedStations.map((item) => item.key);
    this.state = {
      selectedRowKeys: selectedRowKeys || [],
      selectedRows: this.props.selectedStations,
      dataSource: [],
      ...this.setTableConfig(),
    };
    this.generateSchema();
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  generateTableButtons() {}

  fetchStationList = (params) => {
    // needKw优化查询,全量的时候传该参数
    fetchHandler("", {
      ...params,
      needKw: 0,
    }).then((res) => {
      if (res && res.code === "success") {
        const dataSource = res.data;
        this.setState(
          {
            dataSource,
          },
          () => {
            this.setState({
              ...this.setTableConfig(),
            });
          },
        );
      }
    });
  };

  // 表格列的定义
  generateSchema() {
    this.formConfig = {
      childItems: this.props.stationType
        ? [
          {
            param: {
              name: "city", // 与form表单绑定的参数名
              type: "array",
            },
            // defaultValue: ['34'], //默认值
            required: !1,
            labelName: this.internationalization.title1, // '地区',
            format: this.props.format, // 数据格式化之后给formcore
            plugin: this.props.cityDataFilter[0](
              this.internationalization.placeholder1,
              "city",
              false,
            ), // 最后一个参数指是否显示到区
          },
          {
            type: "select",
            placeholder: this.internationalization.placeholder, // '请选择',
            options: [
              {
                text: this.internationalization.all, // '全部',
                value: "",
              },
              {
                text: this.internationalization.type1, // '自营',
                value: "1",
              },
              {
                text: this.internationalization.type2, // '非自营',
                value: "0",
              },
            ],
            defaultValue: "",
            param: {
              name: "type",
              type: "string",
            },
            labelName: this.internationalization.title2, // '运营类型'
          },
          {
            type: "input",
            inputType: "text",
            placeholder: this.internationalization.title3, // '电站名称',
            param: {
              name: "keywords",
              type: "string",
            },
            labelName: this.internationalization.title3, // '电站名称'
          },
          {
            type: "buttonGp", // 表单最终执行组
            buttonArr: [
              {
                btnType: "button",
                text: this.internationalization.btn1, // '查询',
                // icon: 'search',
                type: "primary",
                handler: (e, param) => {
                  this.fetchStationList(param);
                },
              },
            ],
          },
        ]
        : [
          {
            param: {
              name: "city", // 与form表单绑定的参数名
              type: "array",
            },
            // defaultValue: ['34'], //默认值
            required: !1,
            labelName: this.internationalization.title1, // '地区',
            format: this.props.format, // 数据格式化之后给formcore
            plugin: this.props.cityDataFilter[0](
              this.internationalization.placeholder1,
              "city",
              false,
            ), // 最后一个参数指是否显示到区
          },
          {
            type: "input",
            inputType: "text",
            placeholder: this.internationalization.title3, // '电站名称',
            param: {
              name: "keywords",
              type: "string",
            },
            disabled: false, // 是否禁用：新增时则为false,编辑为true
            labelName: this.internationalization.title3, // '电站名称'
          },
          {
            type: "buttonGp", // 表单最终执行组
            buttonArr: [
              {
                btnType: "button",
                text: this.internationalization.btn1, // '查询',
                // icon: 'search',
                type: "primary",
                handler: (e, param) => {
                  this.fetchStationList(param);
                },
              },
            ],
          },
        ], // 设置表单元素
      layout: "inline", // 设置布局 0：横向布局 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        type: this.props.type,
      },
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "ac_stationList_del",
    };
  }

  setTableConfig() {
    return {
      tableConfig: {
        tableColumns: [
          {
            name: this.internationalization.title1, // '地区',
            key: "cityStr",
          },
          {
            name: this.internationalization.title3, // '电站名称',
            key: "name",
          },
          {
            name: this.internationalization.title2, // '运营类型',
            key: "type",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text}` === "1"
                ? this.internationalization.type1
                : this.internationalization.title2;
            },
          },
          {
            name: this.internationalization.action, // '操作',
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            actionMap: [
              {
                type: "confirm",
                actionName: this.internationalization.btn2, // '删除',
                handler: (record) => {
                  this.props.delete([record]);
                  // let selectedRowKeys=this.state.selectedRowKeys;
                  // let selectedRows=this.state.selectedRows;
                  // selectedRowKeys.map((item,index)=>{
                  //     if(item.key===record.key){
                  //         selectedRowKeys.splice(index,1);
                  //         selectedRows.splice(index,1);
                  //     }
                  // })
                  // this.setState({
                  //     selectedRowKeys:selectedRowKeys,
                  //     selectedRows:selectedRows
                  // }, () => {
                  //     this.setState({
                  //         ...this.setTableConfig()
                  //     })
                  // })
                },
              },
            ],
          },
        ],
        tableParam: {
          // type: 1
        },
        tableInfo: {
          hasRow: !0, // 是否显示checkbox
          footer: this.generateTableButtons(),
          rowSelection: {
            selectedRowKeys: this.state ? this.state.selectedRowKeys : [],
            onChange: (selectedRowKeys, selectedRows) => {
              this.setState(
                {
                  selectedRowKeys,
                  selectedRows,
                },
                () => {
                  this.setState({
                    ...this.setTableConfig(),
                  });
                },
              );
            },
            onSelect: () => {
              //     let selectedRowsArr = this.state.selectedRows;
              //     if (selected) {
              //         selectedRowsArr.push(record);
              //     } else {
              //         selectedRowsArr.map((item, index) => {
              //             if (item.key === record.key) {
              //                 selectedRowsArr.splice(index, 1);
              //             }
              //         })
              //     }
              //     this.setState({
              //         selectedRows: selectedRowsArr
              //     })
            },
            onSelectAll: () => {
              //     let selectedRowsArr = this.state.selectedRows;
              //     if (selected) {
              //         selectedRowsArr.push(...changeRows);
              //     } else {
              //         let arr = changeRows.map((item, index) => {
              //             return item.key;
              //         })
              //         selectedRowsArr = selectedRowsArr.filter(item => !arr.includes(item.key));
              //     }
              //     this.setState({
              //         selectedRows: selectedRowsArr
              //     })
            },
          },
        },
        tableChange: () => {
          // grid翻页页，排序， 筛选过滤时触发
        },
        autoRefresh: true, // 设置为true 直接加载grid数据
        // dataApi: stationList,
        dataApi: this.state ? this.state.dataSource : [],
        tableKey: "ac_stationList_del",
      },
    };
  }

  selectAll = () => {
    const dataSource = [...this.state.dataSource];
    const selectedRows = [...this.state.selectedRows];
    // const selectedRowKeys = [...this.state.selectedRowKeys];
    let selected = true;
    if (selectedRows.length === dataSource.length) {
      selected = false;
    }
    this.setState(
      {
        selectedRows: selected ? dataSource : [],
        selectedRowKeys: selected ? dataSource.map((item) => item.key) : [],
      },
      () => {
        console.log(this.state.selectedRows);
        console.log(this.state.selectedRowKeys);
        this.setState({
          ...this.setTableConfig(),
        });
      },
    );
  };

  selectCurrent = () => {
    this.props.addCurrent(this.state.selectedRows);
  };

  batchAdd = () => {
    console.log(this.state.selectedRows);
    this.props.add(this.state.selectedRows);
  };

  render() {
    return (
      <Modal
        title={this.internationalization.title3}
        footer={null}
        visible={this.props.visible}
        destroyOnClose
        onCancel={this.props.cancel}
        width="1000px"
      >
        <FormCore formConfig={this.formConfig} />
        <ScGridTable config={this.state.tableConfig} />
      </Modal>
    );
  }
}

export default injectIntl(EquipmentListModalDel);



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/taskManagement/equipmentListModalDel.js